import React, { useState } from "react";
import {
    Button, FormControl, InputLabel, MenuItem, Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Divider
} from "@material-ui/core";

import StudentService from "./Locality/Service/studentService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import * as Yup from 'yup';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import PageTitle from "../../components/PageTitle/PageTitle";
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function StudentForm(props, history) {
    const { id } = useParams();
    var [error, setError] = useState(null);
    const [age, setAge] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const [cityList, setCityList] = useState([]);
    const [imageslist, setImagesList] = useState('');
        const [imageslist1, setImagesList1] = useState('');

    const [message, setMessage] = useState("");
    const [message1, setMessage1] = useState("");

    const [images, setImages] = useState('');
    const [images1, setImages1] = useState('');

    const classes = useStyles();
    const [gender, setGender] = useState("");
    const [studentList, setStudentList] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [student, setStudent] = useState({
        firstName: '',
        lastName: '',
        dob: '',
        motherName: '',
        fatherName: '',
        mobileNumber: '',
        address: '',
        lane: '',
        // selectCity: '',
        doa: '',
        allergies: '',
        classId: '',
        sectionId: '',
        fatherMobileNumber: '',
        admissionNumber: '',
        gender: '',
        adharNo: '',
    });

    const city = [
        'Mumbai',
        'Delhi',
        'Bagolore',
        'Hyderbad',
        'Chennai',
    ];
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    useEffect(() => {
        getAddClassList();
        if (id !== 'add') {
            getByIdList();
        }
        return () => {
            setStudentList([]);
        }
    }, []);
    const handleChange = (student) => {
        setAge(student.target.value);
    };
    const handleChange1 = (event) => {
        setGender(event.target.value);
    };
    const handleOpen = () => {
        props.history.push('/app/district/studentdetails')
    };
    const handleClose = () => {
        setOpen(false);
    };
    const getByIdList = () => {
        StudentService.getByIdStudent(id).then((res) => {

            setStudent(res);
        }).catch((err) => {
            setError(err.message);
        });
    }

    const handleFileChange = (e) => {
        setImages(e.target.files); // Store all selected files in state
    };
    const handleFileChange1 = (e) => {
        setImages1(e.target.files); // Store all selected files in state
    };
    const validationSchema = Yup.object().shape({
        admissionNumber: Yup.string(),
        firstName: Yup.string().required('student first name  is required'),
        lastName: Yup.string(),
        gender: Yup.string(),
        adharNo: Yup.string().
            matches(/^[0-9]+$/, "Must be only digits")
            .min(12, 'Must be exactly 12 digits')
            .max(12, 'Must be exactly 12 digits'),
        dob: Yup.string().required('select date of birth'),
        classId: Yup.string().required('select class'),
        sectionId: Yup.string(),
        motherName: Yup.string().required('mother name  is required'),
        fatherName: Yup.string(),
        mobileNumber: Yup.string()
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(10, 'Must be exactly 10 digits')
            .max(10, 'Must be exactly 10 digits'),
        fatherMobileNumber: Yup.string(),
        address: Yup.string(),
        lane: Yup.string(),
        // selectCity: Yup.string().required('select city'),
        doa: Yup.string().required('select date of admission'),
        allergies: Yup.string(),

    });


    const getStudentList = () => {
        StudentService.getAllStudent().then((res) => {
            setStudentList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        AddClassService.getAllAddClass(userDetails.schooleId)
            .then((res) => {
                const list = Array.isArray(res) ? res : [];
                const map = new Map();
                for (const item of list) {
                    const key = String(item?.className || "").trim().toLowerCase();
                    if (!key) continue;
                    if (!map.has(key)) map.set(key, item);
                }
                const unique = Array.from(map.values()).sort((a, b) =>
                    String(a?.className || "").localeCompare(String(b?.className || ""))
                );
                setAddClassList(unique);
            })
            .catch(() => {
                setAddClassList([]);
            });
    }

    const getSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };
    const handleUpload = async (e) => {
        e.preventDefault();

        if (images.length === 0) {
            setMessage("Please select images first.");
            return;
        }

        // Create FormData and append each file
        const formData = new FormData();
        if (images.length > 0) {
            const image = images[0];
            formData.append(`image`, image);

            formData.append(`imageName`, image.name);
            // images.forEach((image, index) => {
            //   formData.append(`images`, image); // Append each file to the form
            // });

            try {
                // Send the images to the API
                StudentService.uploadImage(formData).then((res) => {

                    alert(`Images uploaded successfully`);
                    setImagesList((prev) => [...prev, res.url]);


                }).catch((err) => {
                    alert(err.message);
                });
            } catch (error) {
                console.error("Error uploading images:", error);
                setMessage("An error occurred while uploading the images.");
            }
        }

    };
    const handleUpload1 = async (e) => {
        e.preventDefault();

        if (images1.length === 0) {
            setMessage1("Please select images first.");
            return;
        }

        // Create FormData and append each file
        const formData = new FormData();
        if (images1.length > 0) {
            const image = images1[0];
            formData.append(`image`, image);

            formData.append(`imageName`, image.name);
            // images.forEach((image, index) => {
            //   formData.append(`images`, image); // Append each file to the form
            // });

            try {
                // Send the images to the API
                StudentService.uploadImage(formData).then((res) => {

                    alert(`Images uploaded successfully`);
                    setImagesList1(res.url);


                }).catch((err) => {
                    alert(err.message);
                });
            } catch (error) {
                console.error("Error uploading images:", error);
                setMessage("An error occurred while uploading the images.");
            }
        }

    };
    const deleteStudent = (studentdelete) => {
        if (studentdelete) {
            StudentService.deleteStudent(studentdelete).then((res) => {
                getStudentList();
            }).catch((err) => {
            });
        }
    };
    const getStudentImageList = (studentId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        const keys = {
            "schooleId": userDetails.schooleId,

            "studentId": userDetails.studentId
        }
        StudentService.creteImages(keys).then((res) => {

            //   setStudentList([]);
            alert(" Event Successfully.");
        }).catch((err) => {

        });
    }
    const formik = useFormik({
        initialValues: student,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            // Backend expects ObjectId or omit; empty string causes "Cast to ObjectId" error
            if (values.sectionId === "") {
                delete values.sectionId;
            }
            if (student._id) {
                StudentService.upadeStudent(values).then((res) => {
                    setImagesList([])
                    alert("Student Registration Updated Successfully.");
                    props.history.push('/app/studentdetails');

                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }
            else {
                values.imageURL = imageslist;
                values.profileURL = imageslist1;
                StudentService.creteStudent(values).then((res) => {
                    setImagesList([])
                    alert(" Student Registration Successfully.");
                    props.history.push('/app/studentdetails');
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {

                        alert(err.response.data.message)
                    })
            }
        },
    });

    useEffect(() => {
        // Whenever selected class changes (including when editing an existing student),
        // load the corresponding sections so the section dropdown is populated.
        if (formik.values.classId) {
            getSectionListByClass(formik.values.classId);
        } else {
            setSectionList([]);
        }
    }, [formik.values.classId]);

    return (
        <>
            <Card sx={{ maxWidth: 'none', margin: '20px', padding: '20px' }}>
                <Box>
                    <div style={{ padding: '0 20px' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <PageTitle InputProps={{ style: { color: '#10b680' } }} title=" Student Registration" ></PageTitle>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Uplaod Student Photo:</span>
                            </Grid> 
                            <Grid item xs={12} sm={12} md={6}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    // Enable multiple file selection
                                    onChange={handleFileChange1}
                                />
                                <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', border: 'none' }} onClick={handleUpload1}>Upload</Button>

                                {imageslist.length > 0 && (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                        {imageslist.map((url, index) => (
                                            <img
                                                key={index}
                                                src={url}
                                                alt={`Uploaded ${index + 1}`}
                                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField fullWidth
                                    margin="dense"

                                    id="admissionNumber"
                                    name="admissionNumber"
                                    label="Admission Number "
                                    type="text"
                                    autoFocus
                                    variant="outlined"
                                    value={formik.values.admissionNumber}
                                    onChange={formik.handleChange}
                                    error={formik.touched.admissionNumber && Boolean(formik.errors.admissionNumber)}
                                    helperText={formik.touched.admissionNumber && formik.errors.admissionNumber}
                                />
                            </Grid>

                            {/* First Name and Last Name in the same row */}
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField fullWidth
                                    margin="dense"
                                    
                                    id="firstName"
                                    name="firstName"
                                    label="First Name "
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.firstName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                    helperText={formik.touched.firstName && formik.errors.firstName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField fullWidth
                                    margin="dense"

                                    id="lastName"
                                    name="lastName"
                                    label="Last Name "
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                    helperText={formik.touched.lastName && formik.errors.lastName}
                                />
                            </Grid>
                            
                            {/* Date of Birth and Gender in the same row */}
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField 
                                    fullWidth
                                    margin="dense"
                                    id="dob"
                                    name="dob"
                                    label="Date Of Birth"
                                    type="date"
                                    min="2016-11-10"
                                    max="2022-11-10"
                                    variant="outlined"
                                    value={formik.values.dob}
                                    onChange={formik.handleChange}
                                    error={formik.touched.dob && Boolean(formik.errors.dob)}
                                    helperText={formik.touched.dob && formik.errors.dob}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Gender</FormLabel>
                                    <RadioGroup
                                        row
                                        name="gender"
                                        id="gender"
                                        value={formik.values.gender}
                                        onChange={formik.handleChange}
                                    >
                                        <FormControlLabel value="male" control={<Radio />} label="Male" />
                                        <FormControlLabel value="female" control={<Radio />} label="Female" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl 
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <InputLabel id="class-select-label">Select Class</InputLabel>
                                    <Select
                                        labelId="class-select-label"
                                        id="class-select"
                                        name="classId"
                                        label="Select Class"
                                        value={formik.values.classId}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            getSectionListByClass(e.target.value);
                                            // Reset section when class changes
                                            formik.setFieldValue("sectionId", "");
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.classId && formik.errors.classId && (
                                        <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4 }}>
                                            {formik.errors.classId}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                >
                                    <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                                    <Select
                                        labelId="section-select-label"
                                        id="section-select"
                                        name="sectionId"
                                        label="Select Section (Optional)"
                                        value={formik.values.sectionId || ""}
                                        onChange={formik.handleChange}
                                        disabled={!formik.values.classId || sectionList.length === 0}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {sectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Family Details:</span>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="motherName"
                                    name="motherName"
                                    label="Mother Name"
                                    type="text"
                                   
                                    variant="outlined"
                                    value={formik.values.motherName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.motherName && Boolean(formik.errors.motherName)}
                                    helperText={formik.touched.motherName && formik.errors.motherName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>

                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="mobileNumber"
                                    name="mobileNumber"
                                    label="Mother Number(parent login)"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.mobileNumber}
                                    // value={editId ? formik.values.mobileNumber:''}
                                    onChange={formik.handleChange}
                                    error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                                    helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="fatherName"
                                    name="fatherName"
                                    label="Father Name"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.fatherName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.fatherName && Boolean(formik.errors.fatherName)}
                                    helperText={formik.touched.fatherName && formik.errors.fatherName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>

                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="fatherMobileNumber"
                                    name="fatherMobileNumber"
                                    label="Father Number"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.fatherMobileNumber}
                                    onChange={formik.handleChange}
                                    error={formik.touched.fatherMobileNumber && Boolean(formik.errors.fatherMobileNumber)}
                                    helperText={formik.touched.fatherMobileNumber && formik.errors.fatherMobileNumber}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Uplaod Student Masked Adhar Card:</span>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    // Enable multiple file selection
                                    onChange={handleFileChange}
                                />
                                <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', border: 'none' }} onClick={handleUpload}>Upload</Button>

                                {imageslist.length > 0 && (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                        {imageslist.map((url, index) => (
                                            <img
                                                key={index}
                                                src={url}
                                                alt={`Uploaded ${index + 1}`}
                                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>

                                <TextField
                                    fullWidth

                                    margin="dense"
                                    id="adharNo"
                                    name="adharNo"
                                    label="Aadhaar number"
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.adharNo}
                                    onChange={formik.handleChange}
                                    error={formik.touched.adharNo && Boolean(formik.errors.adharNo)}
                                    helperText={formik.touched.adharNo && formik.errors.adharNo}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad' }} >Address:</span>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="address"
                                    name="address"
                                    placeholder="Door/Flat/domicile number "
                                    label="Address "
                                    type="text"
                                    variant="outlined"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    error={formik.touched.address && Boolean(formik.errors.address)}
                                    helperText={formik.touched.address && formik.errors.address}
                                />



                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField 
                                    fullWidth
                                    margin="dense"
                                    id="doa"
                                    name="doa"
                                    label="Date Of Admission"
                                    type="date"
                                    variant="outlined"
                                    value={formik.values.doa}
                                    onChange={formik.handleChange}
                                    error={formik.touched.doa && Boolean(formik.errors.doa)}
                                    helperText={formik.touched.doa && formik.errors.doa}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="allergies"
                                    name="allergies"
                                    label="Allergies if any"
                                    type="text"
                                    variant="outlined"
                                    onChange={formik.handleChange}
                                    value={formik.values.allergies}
                                    error={formik.touched.allergies && Boolean(formik.errors.allergies)}
                                    helperText={formik.touched.allergies && formik.errors.allergies}
                                />
                            </Grid>
                        </Grid>

                        <div style={{ textAlign: 'right', margin: '40px 20px 20px 20px' }}>
                            <Button 
                                style={{ backgroundColor: '#6c757d', color: 'white', marginRight: '10px' }} 
                                onClick={() => setPreviewOpen(true)}
                                variant="contained"
                            >
                                Preview
                            </Button>
                            <Button 
                                style={{ backgroundColor: ' rgb(15 59 98)', color: 'white' }} 
                                onClick={formik.handleSubmit}
                                type="submit" 
                                variant="contained"
                            >
                                Submit
                            </Button>
                        </div>

                    </div>
                </Box>
            </Card>

            {/* Preview Dialog */}
            <Dialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '20px'
                    }
                }}
            >
                <DialogTitle style={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold', color: '#0f3b62' }}>
                    Student Registration Preview
                </DialogTitle>
                <DialogContent>
                    <Box style={{ padding: '20px' }}>
                        {/* Student Photo */}
                        {imageslist.length > 0 && (
                            <Box style={{ textAlign: 'center', marginBottom: '20px' }}>
                                <Typography variant="h6" style={{ marginBottom: '10px', color: '#0f3b62' }}>
                                    Student Photo
                                </Typography>
                                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                    {imageslist.map((url, index) => (
                                        <img
                                            key={index}
                                            src={url}
                                            alt={`Student ${index + 1}`}
                                            style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "8px", border: "2px solid #e0e0e0" }}
                                        />
                                    ))}
                                </div>
                            </Box>
                        )}

                        <Divider style={{ margin: '20px 0' }} />

                        {/* Basic Information */}
                        <Typography variant="h6" style={{ marginBottom: '15px', color: '#0f3b62', fontWeight: 'bold' }}>
                            Basic Information
                        </Typography>
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Admission Number:</Typography>
                                <Typography variant="body1">{formik.values.admissionNumber || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>First Name:</Typography>
                                <Typography variant="body1">{formik.values.firstName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Last Name:</Typography>
                                <Typography variant="body1">{formik.values.lastName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Date of Birth:</Typography>
                                <Typography variant="body1">{formik.values.dob || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Gender:</Typography>
                                <Typography variant="body1">{formik.values.gender || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Class:</Typography>
                                <Typography variant="body1">{formik.values.classId || 'Not provided'}</Typography>
                            </Grid>
                        </Grid>

                        <Divider style={{ margin: '20px 0' }} />

                        {/* Family Details */}
                        <Typography variant="h6" style={{ marginBottom: '15px', color: '#0f3b62', fontWeight: 'bold' }}>
                            Family Details
                        </Typography>
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Mother's Name:</Typography>
                                <Typography variant="body1">{formik.values.motherName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Father's Name:</Typography>
                                <Typography variant="body1">{formik.values.fatherName || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Mobile Number:</Typography>
                                <Typography variant="body1">{formik.values.mobileNumber || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Father's Mobile:</Typography>
                                <Typography variant="body1">{formik.values.fatherMobileNumber || 'Not provided'}</Typography>
                            </Grid>
                        </Grid>

                        <Divider style={{ margin: '20px 0' }} />

                        {/* Additional Information */}
                        <Typography variant="h6" style={{ marginBottom: '15px', color: '#0f3b62', fontWeight: 'bold' }}>
                            Additional Information
                        </Typography>
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={12}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Address:</Typography>
                                <Typography variant="body1">{formik.values.address || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Lane:</Typography>
                                <Typography variant="body1">{formik.values.lane || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Aadhar Number:</Typography>
                                <Typography variant="body1">{formik.values.adharNo || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Date of Admission:</Typography>
                                <Typography variant="body1">{formik.values.doa || 'Not provided'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold' }}>Allergies:</Typography>
                                <Typography variant="body1">{formik.values.allergies || 'None'}</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions style={{ padding: '20px', justifyContent: 'center' }}>
                    <Button 
                        onClick={() => setPreviewOpen(false)}
                        style={{ backgroundColor: '#6c757d', color: 'white', marginRight: '10px' }}
                        variant="contained"
                    >
                        Close
                    </Button>
                    <Button 
                        onClick={() => {
                            setPreviewOpen(false);
                            formik.handleSubmit();
                        }}
                        style={{ backgroundColor: '#0f3b62', color: 'white' }}
                        variant="contained"
                    >
                        Submit Registration
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


